import React, { Fragment } from 'react';
import moment from 'moment';
import axios from 'axios';
import { get } from 'lodash';

import TableHeader from '../TableHeader';
import Notification from '../Notification'
import {
  CSRF_TOKEN,
  addNotification,
} from '../../lib/helpers';

const MissionsList = ({ campaignId, missions = [], total = 0 }) => {
  const importMissions = (campaignId) => {
    axios.post(`/${gon.currentProvider}/api/campaigns/${campaignId}/missions/import`, { authenticity_token: CSRF_TOKEN,})
      .then((res) => {
        if (res.status === 200) {
          addNotification({
            message: `Campaign #${campaignId} missions imported successfully`,
            type: Notification.NOTIFICATION_TYPES.success,
          })
        }
      })
      .catch((error) => {
        addNotification({
          message: 'Something went wrong',
          type: Notification.NOTIFICATION_TYPES.error,
        })
      })
      .then(() => {
        window.location.reload()
      })
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Missions list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} missions</p>
        </div>

        <div className='MainHeader__right'>
          <a
            title="Import Missions"
            className='MainHeader__right__a MainHeader__right__a--bright-blue'
            onClick={() => importMissions(campaignId)}
          >
            Import Missions
          </a>
        </div>
      </div>

      <div className='Table Table--missions-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID'
            },
            {
              label: 'Action'
            },
            {
              label: 'Mission Type'
            },
            {
              label: 'Required Actions Count',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Reward Points',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Position',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Updated At',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {missions.map((mission) => (
          <div className={'Table__row'} key={`mission_${mission.id}`}>
            <div className='Table__col'>{mission.id}</div>

            <div className='Table__col'>
              {mission.action}
            </div>

            <div className='Table__col'>{mission.missionType}</div>

            <div className='Table__col Table__col--ta-c'>
              {mission.requiredActionsCount}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {mission.rewardPoints}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {mission.position}
            </div>

            <div className='Table__col'>
              {moment(get(mission, 'updatedAt')).format('YYYY-MM-DD HH:mm')}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default MissionsList
